import {
  login,
  logout,
  siteProjectQueryByCurrentUser,
  regionQueryTree,
  tenementFileTaskList,
  userQueryCurrent,
  queryByDomain
} from '@/api/user'
import { siteProjectAgreementListByProject } from '@/api/manage'

import { querySiteProject } from '@/api/dashboard'
import {
  getToken,
  setToken,
  removeToken,
  getUserInfo,
  setUserInfo,
  removeUserInfo,
  getProject,
  setProject,
  removeProject
} from '@/utils/auth'
import router, { resetRouter } from '@/router'
import moment from 'moment'

let token = ''
const domainName = process.env.VUE_APP_CLIENT_DOMAIN
let child = null

function messageEvent(e) {
  if (e.data === 'onloaded' && child) {
    // 子窗口加载完毕
    child.postMessage(
      JSON.stringify({
        type: 'token',
        data: token
      }),
      domainName
    )
    window.removeEventListener('message', messageEvent)
  }
}

const state = {
  token: getToken(),
  userInfo: getUserInfo(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  projectList: [],
  projectItem: {},
  areaTree: [],
  areaLoading: false,
  taskDialogVisi: false,
  taskListLoading: false,
  taskList: [],
  isVisivle: true,
  userDialogVisi: false,
  userEditDialogVisi: false,
  updatePasswordVisi: false,
  system: {
    SYSTEM_CODE: ''
  },
  projectInfo: {},
  configData: {},
  privateConfig: {},
  queryDomainFinish: false,
  logDialogVisi: false,
  agreementCode: '',
  agreementList: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_PROJECT_LIST: (state, list) => {
    state.projectList = list
  },
  SET_PROJECT_ITEM: (state, item) => {
    state.projectItem = item
  },
  SET_AREA_TREE: (state, data) => {
    state.areaTree = data
  },
  SET_TASK_DIALOG_VISI: (state, taskDialogVisi) => {
    state.taskDialogVisi = taskDialogVisi
  },
  SET_LOG_DIALOG_VISI: (state, logDialogVisi) => {
    state.logDialogVisi = logDialogVisi
  },
  SET_AGREEMENT_CODE: (state, agreementCode) => {
    state.agreementCode = agreementCode
  },
  SET_TASK_LIST: (state, taskList) => {
    state.taskList = taskList
  },
  SET_TASK_LIST_LOADING: (state, taskListLoading) => {
    state.taskListLoading = taskListLoading
  },
  SET_IS_VISIBLE: (state, isVisivle) => {
    state.isVisivle = isVisivle
  },
  SET_USERDIALOG_VISI: (state, userDialogVisi) => {
    state.userDialogVisi = userDialogVisi
  },
  SET_USER_EDIT_DIALOG_VISI: (state, userEditDialogVisi) => {
    state.userEditDialogVisi = userEditDialogVisi
  },
  SET_UPDATE_PASSWORD_VISI: (state, updatePasswordVisi) => {
    state.updatePasswordVisi = updatePasswordVisi
  },
  SET_PRIVATE_CONFIG: (state, data) => {
    state.privateConfig = data
  },
  QUERY_DOMAIN_FINISH: (state, data) => {
    state.queryDomainFinish = data
  },
  SET_AGREEMENT_LIST: (state, data) => {
    state.agreementList = data
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo)
        .then((response) => {
          const { data } = response
          if (userInfo.clientType === 'WEB_SITE_C') {
            commit('SET_TOKEN', data.tokenHead + data.token)
            setToken(data.tokenHead + data.token)
            commit('SET_USERINFO', data.userInfo)
            setUserInfo(JSON.stringify(data.userInfo))
          } else {
            window.addEventListener('message', messageEvent)
            token = data.tokenHead + data.token
            child = window.open(`${domainName}/#/avoid-login`, '_blank')
          }
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  siteProjectQueryByCurrentUser({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      siteProjectQueryByCurrentUser({ projectName: payload.projectNameKeyWord })
        .then((response) => {
          const { data } = response
          commit('SET_PROJECT_LIST', data)
          if (data.length > 0) {
            let item = {}
            if (!payload.isRemoteSearch) {
              const projectId = getProject()
              if (projectId) {
                item =
                  data.find((element) => element.projectId === projectId) || {}
              } else {
                item = data[0] || {}
              }
              setProject(item.projectId)
              if (item.deadlineStatus) {
                if (
                  moment(item.deadlineStartDate).diff(moment()) > 0 ||
                  moment(item.deadlineEndDate).diff(moment()) < 0
                ) {
                  item.isDeadline = true
                }
              }
              commit('SET_PROJECT_ITEM', item)
            }
            resolve({ data, projectItem: item })
          } else {
            reject('账号没有启用的项目！')
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  querySiteProjectId({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      querySiteProject({ projectId: payload.projectId })
        .then((response) => {
          const { data } = response
          commit('SET_PROJECT_ITEM', data)
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAgreementList({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      siteProjectAgreementListByProject({ projectId: payload.projectId })
        .then((response) => {
          const { data } = response
          commit('SET_AGREEMENT_LIST', data)
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // user logout
  logout({ commit, state, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      logout(payload)
        .then(() => {
          commit('SET_TOKEN', '')
          commit('permission/SET_CEHCK_PERMISSION', false, { root: true })
          removeToken()
          removeUserInfo()
          removeProject()
          resetRouter()

          // reset visited views and cached views
          // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
          dispatch('tagsView/delAllViews', null, { root: true })

          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit('SET_TOKEN', '')
      commit('SET_USERINFO', {})
      removeToken()
      removeUserInfo()
      removeProject()
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    const { roles } = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, {
      root: true
    })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, { root: true })
  },
  queryTree({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.areaTree.length > 0) {
        return
      }
      if (state.areaLoading) {
        return
      }
      state.areaLoading = true
      regionQueryTree().then((res) => {
        commit('SET_AREA_TREE', res.data)
        state.areaLoading = false
        resolve()
      })
    })
  },
  getTaskList({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit('SET_TASK_LIST_LOADING', true)
      tenementFileTaskList(payload)
        .then((res) => {
          res.data.records.forEach((element) => {
            element.editLoading = false
          })
          commit('SET_TASK_LIST', res.data.records)
          resolve(res.data)
        })
        .finally(() => {
          commit('SET_TASK_LIST_LOADING', false)
        })
    })
  },
  getUserInfo({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      if (this.token === '') {
        throw Error('GetUserInfo: token is undefined!')
      }
      userQueryCurrent().then((res) => {
        commit('SET_USERINFO', res.data)
        setUserInfo(JSON.stringify(res.data))
      })
    })
  },
  queryByDomain({ commit, state }, payload = {}) {
    return new Promise((resolve, reject) => {
      let domainName = document.domain
      if (domainName.indexOf('localhost') > -1) {
        domainName = 'testapi.hanmawin.com'
      }
      queryByDomain({ clientType: 'WEB_SITE_C', domainName, ...payload }).then(
        (res) => {
          if (!res.data || res.data.auditResult !== 'SUCCESS') {
            res.data = {
              privateName: '项目管理平台',
              privateLoginIconUrl: require('@/assets/images/logo.png'),
              privateIconUrl: require('@/assets/images/logo.png'),
              privateLoginBgUrl: require('../../assets/images/u1.png')
            }
          }
          commit('SET_PRIVATE_CONFIG', res.data)
          const link =
            document.querySelectorAll("link[rel*='icon']") ||
            document.createElement('link')
          if (res.data.privateIconUrl) {
            link.forEach((element) => {
              element.type = 'image/x-icon'
              element.rel = 'shortcut icon'
              const index = res.data.privateIconUrl.indexOf('/')
              element.href = res.data.privateIconUrl.substring(index)
              document.getElementsByTagName('head')[0].appendChild(element)
            })
          }
          resolve(res.data)
        }
      )
    })
  },
  setUserDialogVisi({ commit }, userDialogVisi) {
    commit('SET_USERDIALOG_VISI', userDialogVisi)
  },
  setUserEditDialogVisi({ commit }, userEditDialogVisi) {
    commit('SET_USER_EDIT_DIALOG_VISI', userEditDialogVisi)
  },
  setUpdatePasswordVisi({ commit }, updatePasswordVisi) {
    commit('SET_UPDATE_PASSWORD_VISI', updatePasswordVisi)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
